module.exports = __webpack_public_path__ + "static/media/signature.white.419c00bb.png";